<template>
      <div class="accountTerminologyEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'accountTerminology', params: {} }">
          Account Terminology
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'accountTerminologyEdit', params:{id: id} }">
            Edit Account Terminology
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Account Terminology</v-card-title>
          <v-card-text>
            <accountTerminology-form :id="id"></accountTerminology-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import AccountTerminologyForm from './AccountTerminologyForm.vue';

    export default {
      name: 'accountTerminology',
      data () {
        return {
          id: null
        }
      },
      components: {
        AccountTerminologyForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    